import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'app/environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  private config: any;

  constructor(private http: HttpClient) {}

  loadConfig(): Promise<void> {
  return firstValueFrom(this.http.get<any>('/assets/config.json'))
    .then(async res => {
      this.config = res;

      const apiRes: any = await firstValueFrom(this.GetApiUrl());
      localStorage.setItem('apiURL', apiRes.baseUrl);

      console.log('apiURL set:', apiRes.baseUrl);
    })
    .catch(err => {
      console.error('Config load failed:', err);
    });
}
  getConfig() {
    return this.config;
  }
  GetApiUrl() {
    return this.http.get(`${environment.api}/Domains/by-credentials?clientId=${this.config?.client_id}&clientSecret=${this.config?.client_secret}`);
  }
    get appName(): string {
    return this.config?.appName || 'Default App';
  }
   get logo(): string {
    return this.config?.logo || '/assets/logo/logo.png';
  }
   get default(): string {
    return this.config?.default || '/assets/images/noimage.png';
  }
    get SavedURL(): string {
    const base = localStorage.getItem('apiURL');
    if (!base) throw new Error('apiURL not ready');
    return base + "/api";
  }
      get imageUrl(): string {
    return this.config?.image_url || '';
  }
      get customerUrl(): string {
    return this.config?.customer_url || '';
  }
}
